const support=[
    {
        title: 'Contact Us',
        url:"/contact"
    },
    {
        title: 'Privacy Policy',
        url:"/privacy-policy"
    },
    {
        title: 'Terms And Conditions',
        url:"/terms-and-conditions"
    },
]

export default support